/** Учебная игра в расстановке (13.10, владелец: «в учебных играх … указать, кто из сотрудников и принятых
 *  на работу будет играть, и при расстановке чтобы у ОО была возможность запросить отчёты … друг о друге»).
 *  Строка «Играют: …» под составом: игроков выбирают в брони, на доске их не снимают и не двигают.
 *  Чип игрока — кнопка БЕЗ data-op (лассо копирует [data-op] как состав) и без смахивания; тап — меню
 *  отчётов (PeerMenu). «Друг о друге» — все пары операторы ⇄ игроки разом (есть и состав, и игроки). */
import { useCallback, useState } from "react";
import { PeerMenu, eachOtherPairs, type PeerCtx } from "./PeerMenu";
import css from "./board.module.css";
import lcss from "./learning.module.css";

export function LearningRow({ learning, ...ctx }: PeerCtx & { /** у брони включён «Учеб» */ learning: boolean }) {
  const [open, setOpen] = useState<string | null>(null);
  const close = useCallback(() => setOpen(null), []);
  const { players, crew } = ctx;
  if (!players.length && !learning) return null;
  return (
    <div className={lcss.row}>
      <span className={lcss.lbl}>Играют</span>
      {players.length ? null : <span className={lcss.none}>не указаны в брони</span>}
      {players.map((p) => (
        <span key={p.id} className={css.chipWrap}>
          <button type="button" className={`${lcss.chip} ${open === p.id ? lcss.on : ""}`}
            title="Отчёты: кто о ком"
            onClick={() => setOpen((o) => (o === p.id ? null : p.id))}>
            {p.name}
          </button>
          {open === p.id ? <PeerMenu {...ctx} personId={p.id} kind="player" toggle onClose={close} /> : null}
        </span>
      ))}
      {players.length && crew.length ? (
        <button type="button" className={lcss.each} title="Каждый оператор игры — о каждом игроке, каждый игрок — о каждом операторе"
          onClick={() => ctx.onPeerAdd(eachOtherPairs(ctx))}>Друг о друге</button>
      ) : null}
    </div>
  );
}
